import { z } from "zod";
import {
  ProfessionalCardDataSchema,
  ProfessionalCardContextSchema,
  ProfessionalCardExtractionSchema,
  type ProfessionalCardData,
} from "../../../document/document-types/professional-card";
import type { FieldMessages } from "../../../document/types";
import { createFieldMessagesSchema } from "../../../document/schema";
import { storeResponseSchema } from "../base";
import type { DocumentTypeSchemas } from "../types";

// ===== Internal schemas (not exported) =====

const fieldMessagesSchema = createFieldMessagesSchema(ProfessionalCardDataSchema);

const warnRequestSchema = z.object({
  data: ProfessionalCardDataSchema.partial(),
  context: ProfessionalCardContextSchema,
});

const validateRequestSchema = z.object({
  data: ProfessionalCardDataSchema.partial(),
  context: ProfessionalCardContextSchema,
});

// ===== Exported types (for API client) =====

/** Response type for /extract endpoint */
export type ExtractResponse = z.infer<typeof ProfessionalCardExtractionSchema>;

/** Request body type for /warn endpoint */
export type WarnRequestBody = z.infer<typeof warnRequestSchema>;

/** Response type for /warn endpoint - uses FieldMessages for proper key typing */
export type WarnResponse = FieldMessages<ProfessionalCardData>;

/** Request body type for /validate endpoint */
export type ValidateRequestBody = z.infer<typeof validateRequestSchema>;

/** Response type for /validate endpoint - uses FieldMessages for proper key typing */
export type ValidateResponse = FieldMessages<ProfessionalCardData>;

/** Response type for /store endpoint */
export type StoreResponse = z.infer<typeof storeResponseSchema>;

// ===== Exported bundle (source of truth for route registration) =====

/**
 * Bundled schemas for route factory registration
 */
export const ProfessionalCardSchemas = {
  extractResponse: ProfessionalCardExtractionSchema,
  warnRequest: warnRequestSchema,
  warnResponse: fieldMessagesSchema,
  validateRequest: validateRequestSchema,
  validateResponse: fieldMessagesSchema,
  storeResponse: storeResponseSchema,
} satisfies DocumentTypeSchemas;
